import { LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";

import { ariaBoolean } from "..";
import * as storage from "../storage";
import { MatchesMediaController } from "./controllers/matches-media";

@customElement("bible-book-explore")
export class BookExploreElement extends LitElement {
  @query(".BibleBookExplore__header > .BibleBookExplore__toggle")
  private $desktopToggle?: HTMLElement;

  private get $exploreCta(): HTMLElement | null {
    return document.querySelector("bible-book-explore-cta");
  }

  @query(".BibleBookExplore__header > .BibleBookExplore__close")
  private $mobileClose?: HTMLElement;

  @property()
  isOpenDesktop = !storage.get("desktop.sidebar.collapsed");

  @property()
  isOpenMobile = false;

  private isMobileController = new MatchesMediaController(this, "mobile");

  createRenderRoot() {
    return this;
  }

  disconnectedCallback() {
    this.$desktopToggle?.removeEventListener("click", this);
    this.$exploreCta?.removeEventListener("requestopen", this);
    this.$mobileClose?.removeEventListener("click", this);
  }

  firstUpdated() {
    this.$desktopToggle?.addEventListener("click", this);
    this.$exploreCta?.addEventListener("requestopen", this);
    this.$mobileClose?.addEventListener("click", this);
  }

  handleEvent(e: Event) {
    switch (e.currentTarget) {
      case this.$desktopToggle:
        this.isOpenDesktop = !this.isOpenDesktop;
        storage.set("desktop.sidebar.collapsed", !this.isOpenDesktop);
        break;
      case this.$exploreCta:
        this.isOpenMobile = true;
        break;
      case this.$mobileClose:
        this.isOpenMobile = false;
        this.$exploreCta?.focus();
        break;
      default:
        break;
    }
  }

  willUpdate() {
    if (this.isMobileController.matches) {
      this.setAttribute("data-open-mobile", ariaBoolean(this.isOpenMobile));
      this.$exploreCta?.setAttribute(
        "aria-expanded",
        ariaBoolean(this.isOpenMobile),
      );
    } else {
      this.isOpenMobile = false;
      this.setAttribute("data-open-desktop", ariaBoolean(this.isOpenDesktop));
      this.$desktopToggle?.setAttribute(
        "aria-expanded",
        ariaBoolean(this.isOpenDesktop),
      );
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bible-book-explore": BookExploreElement;
  }
}
